var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 18.958c-4.94 0-8.958-4.018-8.958-8.958S5.06 1.042 10 1.042 18.958 5.06 18.958 10 14.94 18.958 10 18.958m0-16.666c-4.251 0-7.708 3.457-7.708 7.708 0 4.25 3.457 7.708 7.708 7.708 4.25 0 7.708-3.457 7.708-7.708S14.251 2.292 10 2.292m.625 11.458V9.94a.625.625 0 0 0-1.25 0v3.81a.625.625 0 0 0 1.25 0m.225-6.667a.833.833 0 0 0-.833-.833h-.009a.83.83 0 0 0-.83.833c0 .46.379.833.838.833.46 0 .834-.373.834-.833"
})));
export default SvgInfoCircle;